import React from 'react';
import c from 'classnames';

import { truncate } from './styles';
import type { TypographyType, TypographyVariants } from './types';

const getDefaultComponent = (variant?: TypographyVariants, raw?: boolean) => {
  if (raw) return 'span';
  switch (variant) {
    case 'body-short-01':
    case 'body-short-02':
    case 'body-short-03':
    case 'body-long-01':
    case 'body-long-02':
    case 'body-long-03':
      return 'p';
    case 'display-xxxl':
      return 'h1';
    case 'display-xxl':
      return 'h2';
    default:
      return 'span';
  }
};

const Typography = React.forwardRef<HTMLElement, React.PropsWithChildren<TypographyType>>(
  (props, ref) => {
    const {
      children,
      className,
      color,
      numberOfLines,
      raw,
      style,
      variant,
      as: Component = getDefaultComponent(variant, raw),
      ...rest
    } = props;

    return (
      <Component
        ref={ref as any}
        className={c(
          'm-0',
          raw ? '' : variant,
          className,
          color,
          numberOfLines && truncate(numberOfLines),
        )}
        {...rest}>
        {children}
      </Component>
    );
  },
);

Typography.displayName = 'Typography';

export default Typography;
